let defaultApiUrl = 'https://api-nguc.weblink.se';

// Are we in a browser environment?
if(globalThis.window) {
	if(window.sessionStorage && window.sessionStorage.getItem('API_URL') !== null) {
		defaultApiUrl = window.sessionStorage.getItem('API_URL') ?? "";
	}

	if(window.localStorage && window.localStorage.getItem('API_URL') !== null) {
		defaultApiUrl = window.localStorage.getItem('API_URL') ?? "";
	}
}

if(defaultApiUrl[defaultApiUrl.length - 1] === '/') {
	defaultApiUrl = defaultApiUrl.substring(0, defaultApiUrl.length - 1)
}

export const DEFAULT_API_URL = defaultApiUrl;
// export default const apiUrl = "https://api-nguc.jakob.dev.weblink.se";
export const USE_SAML = true;
// TODO MFA
// const USE_MFA = true;
export let apiUrl = DEFAULT_API_URL;

export function setApiUrl(url: string) {
	apiUrl = url;
}
